import { render, staticRenderFns } from "./priceTemplates.vue?vue&type=template&id=112dacdc&scoped=true"
import script from "./priceTemplates.vue?vue&type=script&lang=js"
export * from "./priceTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112dacdc",
  null
  
)

export default component.exports